module.exports = function($) {
  return $.fn.ready = (function(proceed) {
    return function(unsafe) {
      var safely;
      safely = function() {
        var e, err, msg;
        try {
          return unsafe.apply(this, arguments);
        } catch (error) {
          e = error;
          msg = 'Exception in a jQuery.ready callback: ';
          if (window.console && typeof console.error === 'function') {
            console.error(msg, e);
          } else {
            err = new Error(msg + e.message);
            err.original = e;
            setTimeout((function() {
              throw err;
            }), 0);
          }
        }
      };
      return proceed(safely);
    };
  })($.fn.ready);
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL3NyYy9mcm9udGVuZC9jb3JlL2pxdWVyeS5zYWZlLXJlYWR5LmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9Vc2Vycy9za2ltL3Nscy9zcmMvZnJvbnRlbmQvY29yZS9qcXVlcnkuc2FmZS1yZWFkeS5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBR0EsTUFBTSxDQUFDLE9BQVAsR0FBaUIsU0FBQyxDQUFEO1NBRWYsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxLQUFMLEdBQWdCLENBQUEsU0FBQyxPQUFEO1dBR2QsU0FBQyxNQUFEO0FBR0UsVUFBQTtNQUFBLE1BQUEsR0FBUyxTQUFBO0FBQ1AsWUFBQTtBQUFBO0FBQ0UsaUJBQU8sTUFBTSxDQUFDLEtBQVAsQ0FBYSxJQUFiLEVBQW1CLFNBQW5CLEVBRFQ7U0FBQSxhQUFBO1VBRU07VUFDSixHQUFBLEdBQU07VUFDTixJQUFHLE1BQU0sQ0FBQyxPQUFQLElBQW1CLE9BQU8sT0FBTyxDQUFDLEtBQWYsS0FBd0IsVUFBOUM7WUFDRSxPQUFPLENBQUMsS0FBUixDQUFjLEdBQWQsRUFBbUIsQ0FBbkIsRUFERjtXQUFBLE1BQUE7WUFHRSxHQUFBLEdBQVUsSUFBQSxLQUFBLENBQU0sR0FBQSxHQUFNLENBQUMsQ0FBQyxPQUFkO1lBQ1YsR0FBRyxDQUFDLFFBQUosR0FBZTtZQUNmLFVBQUEsQ0FBVyxDQUFFLFNBQUE7QUFBRyxvQkFBTTtZQUFULENBQUYsQ0FBWCxFQUE2QixDQUE3QixFQUxGO1dBSkY7O01BRE87YUFjVCxPQUFBLENBQVEsTUFBUjtJQWpCRjtFQUhjLENBQUEsQ0FBSCxDQUFjLENBQUMsQ0FBQyxFQUFFLENBQUMsS0FBbkI7QUFGRSJ9
